import $ from 'jquery';
const chliRte = {
    methods : {
          anchorButtonClickHandler: function(){
              $('.chlirte a').on('click', function() {
                let buttonText = $(this)[0].innerText;
                let section;
                 section = $(this).closest('.contactus');
                let titleText;
                titleText = section.closest('.genericContainer').prev('.genericContainer').find('.chli_title .heading-2')[0].innerText.trim();
                if(titleText==""){
                      let closestGenericContainer = section.closest('.genericContainer');
                      titleText = closestGenericContainer.parents('.genericContainer').prev('.genericContainer').find('.chli_title .heading-2')[0].innerText.trim();
                      if(titleText==""){
                              section =  $(this).parents('.chlirte');
                              titleText = section.prev('.chlititle').find('.chli_title .heading-2')[0].innerText.trim();
                      }
                      }
                let obj = chliRte.methods.dataLayerObj(buttonText,titleText);
                 createDataLayer('buttonClick',obj);
              });
           },
                dataLayerObj: function (e,el) {
                          var obj = {
                            'articleName': "",
                            'blogCategory': "",
                            'blogPageCategory': "",
                            'buttonText': e ? e.replace(/\n/g, '').trim(): "",
                            'pageSection': el ? el : "",
                            'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.length) === ".com/" ? "Home" : "Other Pages" : "Blog Details Page",
                            'planOption': "",
                            'productCategory': "",
                            'productName': "",
                            'question': "",
                            'source': "",
                            'searchTerm': "",
                            'videoTitle': "",
                            'bannerName': "",
                          };
                          return obj;
                        },
    },
};

$(document).ready(function() {
    chliRte.methods.anchorButtonClickHandler();
});
